import axios from "axios";
import { APXURL, AOURL, OTURL } from "./../Config.jsx"


class Services {
  data;
  constructor(data) {
    this.data = data;
    this.data.Service.GetReport = this.getReport.bind(this);
    this.data.Service.CreateFreeTrial = this.createFreeTrial.bind(this);
    this.data.Service.GetAPXTokenForCustomer = this.getAPXTokenForCustomer.bind(this);
    this.data.Service.AddAccountManagementHistoryItem = this.addAccountManagementHistoryItem.bind(this);
    this.data.Service.GetAccountManagementHistoryList = this.getAccountManagementHistoryList.bind(this);
    this.data.Service.SendDocumentUploadURL = this.sendDocumentUploadURL.bind(this);
    this.data.Service.SendManageAccountURL = this.sendManageAccountURL.bind(this);
    this.data.Service.ReTier = this.reTier.bind(this);
    this.data.Service.GetAccountDetails = this.getAccountDetails.bind(this);

  }

  /// ***************************************************************
  ///  Add Account Management History
  /// ****************************************************************
  getAccountManagementHistoryList(customerToken, type) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + customerToken
      }
    };

    axios.get(APXURL + "/api/merchantwebapi/v7/registration/accountmanagementhistorylist?type=" + type, axiosConfig)
      .then(response => {
        this.data.Service.GetAccountManagementHistoryListCallback(response.data.Item.List);
        this.data.Service.FirmNameCallback(response.data.Item.FirmName);
      })
      .catch(error => {
        //this.data.Service.ErrorCallback(error.response.data.DisplayMessage);
      });
  }

  /// ***************************************************************
  ///  Add Account Management History
  /// ****************************************************************
  addAccountManagementHistoryItem(data, customerToken) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + customerToken
      }
    };

    axios.post(APXURL + "/api/merchantwebapi/v7/registration/accountmanagementhistory", data, axiosConfig)
      .then(response => {
      })
      .catch(error => {
        this.data.Service.ErrorCallback(error.response.data.DisplayMessage);
      });
  }

  /// ***************************************************************
  ///  Send Document Upload URL
  /// ****************************************************************
  sendDocumentUploadURL(data, customerToken) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + customerToken
      }
    };

    axios.post(APXURL + "/api/merchantwebapi/v7/registration/documentuploadurl", data, axiosConfig)
      .then(response => {
        this.data.Service.SuccessCallback("A Document Request was successfully created and send.");
        this.data.Service.SendDocumentUploadURLCallback();
      })
      .catch(error => {
        this.data.Service.ErrorCallback(error.response.data.Message);
      });
  }

  /// ***************************************************************
  ///  Re Tier
  /// ****************************************************************
  reTier(data, customerToken) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + customerToken
      }
    };

    axios.post(APXURL + "/api/merchantwebapi/v7/registration/retier", data, axiosConfig)
      .then(response => {
        this.data.Service.ReTierCallback();
        this.data.Service.SuccessCallback("Account retiered successfully.");
      })
      .catch(error => {
        this.data.Service.ReTierCallback();
        this.data.Service.ErrorCallback(error.response.data.Message);
      });
  }

  /// ***************************************************************
  /// Get Report Binary data
  /// ****************************************************************
  getReport(request) {
    request.MerchantAccounts = [];
    this.data.Finance.showProgress(true);
    return axios.request({
      responseType: 'blob',
      url: APXURL + "/api/merchantwebapi/v7/reporting/Report/?json=" + encodeURIComponent(JSON.stringify(request)),
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.data.Login.ApxToken
      },
    }).then((result) => {
      this.data.Finance.showProgress(false);
      this.data.Service.GetReportCallback(result.data, request.isCSV);
    })
      .catch(error => {
        this.data.Finance.showProgress(false);
        this.data.Service.ErrorCallback(error.message);
      });
  }

  getAPXToken(code) {
    let me = this;
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
      }
    };

    let request = {
      code: code
    };

    axios.post(APXURL + "/api/merchantwebapi/v7/authentication/sso", request, axiosConfig)
      .then(response => {
        me.data.Login.ApxToken = response.data.Item.AuthToken;
        me.data.Login.Secret = response.data.Item.Secret;
        me.data.Login.FirstName = response.data.Item.FirstName;
        me.data.Login.LastName = response.data.Item.LastName;
        me.data.Login.Email = response.data.Item.Email;
        me.data.Login.Modules = response.data.Item.Modules;
        me.data.Login.GetTokenCallback(response.data.Item, null);
      })
      .catch(error => {
        if (error.response === undefined) {
          me.data.Login.GetTokenCallback("", error.message);
        } else {
          me.data.Login.GetTokenCallback("", error.response.data.DisplayMessage);
        }
        if (me.data.Login.ShowLoginButton)
          me.data.Login.ShowLoginButton(true);
      });
  }

  getAPXTokenForCustomer(request, callback) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
      }
    };

    axios.post(APXURL + "/api/merchantwebapi/v7/authentication/Token", request, axiosConfig)
      .then(response => {
        callback(response.data.Item);
      })
      .catch(error => {
        this.data.Service.ErrorCallback(error.response.data.DisplayMessage);
      });
  }

  /// ***************************************************************
  /// Create New Firm - Free Trial
  /// ***************************************************************
  createFreeTrial(request, isOTFreeTrial) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      crossDomain: true,
    };

    let url = "";
    if (isOTFreeTrial) { url = OTURL + "/api/CloudMonitor/FreeTrial"; }
    else { url = AOURL + "/api/CloudMonitor/FreeTrial"; }

    axios.post(url, request, axiosConfig).then(response => {
      if (response.data.ReturnCode !== 0) {
        this.data.Service.ErrorCallback(response.data.DisplayMessage);
      } else {
        if (response.data.Value === true) {
          if (request.isAMSX) {
            this.data.Service.SuccessCallback("The free trial and hosted exchange account are being created. It may take up to 10 minutes to send the login link to the firm. Please advise the firm to check their junk mail folder if they don't see it.");
          }
          else {
            this.data.Service.SuccessCallback("The free trial login has been sent to the firm.  It may take a moment to arrive. Please advise the firm to check their junk mail folder if they don't see it.");
          }
        }
        else {
          this.data.Service.ErrorCallback("Failed to create free trial");
        }
      }
      this.data.Service.FreeTrialCallback(true);
    })
      .catch(error => {
        this.data.Service.ErrorCallback(error.message);
        this.data.Service.FreeTrialCallback(false);
      });
  }

  /// ***************************************************************
  ///  Send Manage Account URL
  /// ****************************************************************
  sendManageAccountURL(data, customerToken) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + customerToken
      }
    };

    axios.post(APXURL + "/api/merchantwebapi/v7/registration/manageaccounturl", data, axiosConfig)
      .then(response => {
        this.data.Service.SuccessCallback("Manage Account Request was successfully created and send.");
        this.data.Service.SendManageAccountURLCallback();
      })
      .catch(error => {
        this.data.Service.ErrorCallback(error.response.data.Message);
      });
  }

  getAccountDetails(customerToken, callback) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + customerToken
      }
    };

    axios.get(APXURL + "/api/merchantwebapi/v7/registration/accounts", axiosConfig)
      .then(response => {
        callback(response.data.Item);
      })
      .catch(error => {
        callback(error.response.data.Message);
      });

  }

  /// ***************************************************************
  /// Create New Firm - Free Trial OT
  /// ***************************************************************
  createFreeTrialOT(request) {
    let axiosConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      crossDomain: true,
    };

    let url = AOURL + "/api/CloudMonitor/FreeTrial";
    axios.post(url, request, axiosConfig).then(response => {
      if (response.data.ReturnCode !== 0) {
        this.data.Service.ErrorCallback(response.data.DisplayMessage);
      } else {
        if (response.data.Value === true) {
          if (request.isAMSX) {
            this.data.Service.SuccessCallback("The free trial and hosted exchange account are being created. It may take up to 10 minutes to send the login link to the firm. Please advise the firm to check their junk mail folder if they don't see it.");
          }
          else {
            this.data.Service.SuccessCallback("The free trial login has been sent to the firm.  It may take a moment to arrive. Please advise the firm to check their junk mail folder if they don't see it.");
          }
        }
        else {
          this.data.Service.ErrorCallback("Failed to create free trial");
        }
      }
      this.data.Service.FreeTrialCallback(true);
    })
      .catch(error => {
        this.data.Service.ErrorCallback(error.message);
        this.data.Service.FreeTrialCallback(false);
      });
  }

}
export default Services;